import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { reads } from 'macro-decorators';

interface SideBarLocationMenuVisitorsComponentSignature {
  Args: {
    trackClickEvent: (trackingString: string) => void;
  };
}

export default class SideBarLocationMenuVisitorsComponent extends Component<SideBarLocationMenuVisitorsComponentSignature> {
  @service declare abilities: AbilitiesService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  @reads('currentAdmin.isGlobalAdmin') isGlobalAdmin!: CurrentAdminService['isGlobalAdmin'];
  @reads('currentAdmin.isLocationAdmin') isLocationAdmin!: CurrentAdminService['isLocationAdmin'];
  @reads('state.currentLocation') currentLocation!: StateService['currentLocation'];

  get canViewDeviceAlertsNav(): boolean {
    return this.abilities.can('update printer notifications') || this.abilities.can('update device notifications');
  }

  get canViewWelcomePage(): boolean {
    if (!this.state.currentUser.visitorsProductVideosEnabled) return false;
    if (!this.featureFlags.isEnabled('webinar-signup')) return false;
    return this.isGlobalAdmin || this.isLocationAdmin;
  }
}
